// src/utils/api.js

import axios from "axios";
import BaseUrl from "../BaseUrl";
import { decode as base64_decode, encode as base64_encode } from "base-64";

export const fetchHelicopterData = () => {
  const token = localStorage.getItem("authorization");
  const config = {
    method: 'post',
    url: BaseUrl() + "get-helicopter-data",
    headers: {
      authorization: `bearer ${token}`,
    },
  };

  return axios(config)
    .then((response) => response.data.getHelicopter);
};

export const updateHelicopterStatusApi = async (value, id) => {
    const url = BaseUrl() + "admin/update-status_helicopter";
    const data = {
      Einsatzbereit_in: value,
      id: id
    };
    const token = localStorage.getItem("authorization");
    const auth1 = {
      headers: {
        authorization: `bearer ${token}`,
      },
    };
  
    return axios.post(url, data, auth1);
  };

  export const handleVisibilityToggleApi = async (id, newVisibility) => {
    const url = BaseUrl() + "admin/update-visibility-helicopter";
    const data = {
      id: id,
      visibility: newVisibility
    };
    const token = localStorage.getItem("authorization");
    const auth = {
      headers: {
        authorization: `bearer ${token}`,
      },
    };
  
    return axios.post(url, data, auth);
  };

export const createFireInDatabase = async (lng, lat) => {
  const token = localStorage.getItem("authorization");
  const userId = base64_decode(localStorage.getItem("userId"));
  const config = {
    method: 'post',
    url: BaseUrl() + "create-fire",
    headers: {
      authorization: `bearer ${token}`,
    },
    data: {
      latitude: lat,
      longitude: lng,
      status: 'active',
      createdBy: userId
    }
  };

  return axios(config).then(response => ({
    fireId: response.data.fireId,
    createdBy: userId
  }));
};

export const fetchExistingFiresApi = async () => {
  const token = localStorage.getItem("authorization");
  const config = {
    method: 'get',
    url: BaseUrl() + "get-fires",
    headers: {
      authorization: `bearer ${token}`,
    }
  };

  return axios(config).then(response => response.data.fires);
};

export const deleteFireFromDatabase = async (fireId) => {
  const token = localStorage.getItem("authorization");
  const config = {
    method: 'post',
    url: BaseUrl() + "delete-fire",
    headers: {
      authorization: `bearer ${token}`,
    },
    data: {
      fireId: fireId
    }
  };

  return axios(config);
};